export default __webpack_public_path__ + "static/media/ky.e0773ef9.PNG";